import {FC, ReactNode} from 'react'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {FLOOR_PLAN_SCANNING_GUIDELINES_URL} from '@features/floor-plan/constants.ts'

/**
 * "Get the 3D scans app" textual content: subtitle and the numbered TestFlight
 * steps. The optional `qr` slot is rendered between the subtitle and the steps so
 * the layout can reorder it (right column on desktop, under the subtitle on mobile).
 */
export const FloorPlanCaptureSteps: FC<{qr?: ReactNode}> = ({qr}) => {
    const {t} = useTranslation()

    return (
        <>
            <p className="[grid-area:subtitle] text-md text-neutral-700 m-0">
                {t('floor_plan:capture_modal:subtitle')}
            </p>
            {qr}
            <ol className="[grid-area:steps] text-md flex flex-col gap-2 m-0 pl-5 list-decimal list-outside text-neutral-900 [&_li]:list-[inherit] [&_a]:text-purple-700 [&_a]:font-medium [&_a]:underline [&_a]:cursor-pointer">
                <li>{t('floor_plan:capture_modal:step_1')}</li>
                <li>{t('floor_plan:capture_modal:step_2')}</li>
                <li>
                    <Trans
                        i18nKey="floor_plan:capture_modal:step_3"
                        components={{
                            guidelines: (
                                <a
                                    href={FLOOR_PLAN_SCANNING_GUIDELINES_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                />
                            )
                        }}
                    />
                </li>
            </ol>
        </>
    )
}
